import { Routes } from '@angular/router';

//Route for content layout with sidebar, navbar and footer.

export const Full_ROUTES: Routes = [
  {
    path: 'dashboard',
    loadChildren: () =>
      import('../../dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: 'admin-users',
    loadChildren: () =>
      import('../../admin-users/admin-users.module').then(
        (m) => m.AdminUsersModule
      ),
  },
  {
    path: 'medics',
    loadChildren: () =>
      import('../../medic-users/medic-users.module').then(
        (m) => m.MedicUsersModule
      ),
  },
  {
    path: 'patients',
    loadChildren: () =>
      import('../../patients/patients.module').then((m) => m.PatientsModule),
  },
  {
    path: 'users',
    loadChildren: () =>
      import('../../users/users.module').then((m) => m.UsersModule),
  },
  {
    path: 'recipes',
    loadChildren: () =>
      import('../../recipes/recipes.module').then((m) => m.RecipesModule),
  },

  {
    path: 'app-alerts',
    loadChildren: () =>
      import('../../app-alerts/app-alerts.module').then(
        (m) => m.AppAlertsModule
      ),
  },

  {
    path: 'recipe-tags',
    loadChildren: () =>
      import('../../recipe-tags/recipe-tags.module').then(
        (m) => m.RecipeTagsModule
      ),
  },

  {
    path: 'faqs',
    loadChildren: () =>
      import('../../faqs/faqs.module').then((m) => m.FaqsModule),
  },

  {
    path: 'branches-app',
    loadChildren: () =>
      import('../../branches/branches.module').then((m) => m.BranchesModule),
  },

  {
    path: 'banners-app',
    loadChildren: () =>
      import('../../banners/banners.module').then((m) => m.BannersModule),
  },

  {
    path: 'forms',
    loadChildren: () =>
      import('../../forms/forms.module').then((m) => m.FormsModule),
  },

  {
    path: 'tables',
    loadChildren: () =>
      import('../../tables/tables.module').then((m) => m.TablesModule),
  },

  {
    path: 'widgets',
    loadChildren: () =>
      import('../../widgets/widgets.module').then((m) => m.WidgetsModule),
  },

  {
    path: 'charts',
    loadChildren: () =>
      import('../../charts/charts.module').then((m) => m.ChartsModule),
  },

  {
    path: 'faq',
    loadChildren: () => import('../../faq/faq.module').then((m) => m.FaqModule),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('../../profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'pricing',
    loadChildren: () =>
      import('../../pricing/pricing.module').then((m) => m.PricingModule),
  },

  {
    path: 'downloads',
    loadChildren: () =>
      import('../../downloads/downloads.module').then((m) => m.DownloadsModule),
  },
];
